class Nav {
    constructor() {
        let handles = document.querySelectorAll('.js-nav-handle');
        for (let i = 0; i < handles.length; i++) {
            handles[i].addEventListener('click', this.toggleNav);
        }
        this.syncExpanded();
    }

    toggleNav() {
        let matches = document.querySelectorAll('html, body');
        for (let i = 0; i < matches.length; i++) {
            matches[i].classList.toggle('nav-active');
        }

        const isOpen = document.documentElement.classList.contains('nav-active');
        const handles = document.querySelectorAll('.js-nav-handle');
        for (let i = 0; i < handles.length; i++) {
            handles[i].setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
    }

    syncExpanded() {
        const isOpen = document.documentElement.classList.contains('nav-active');
        const handles = document.querySelectorAll('.js-nav-handle');
        for (let i = 0; i < handles.length; i++) {
            handles[i].setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
    }
}

export default Nav;
